'use strict';

module.exports.default = {
    "MS_SOCO_PUBLIC_API_URL": "https://uat-ms-soco-public-api.sociolabs.io",
    "MS_BJ_PUBLIC_API_URL": "https://uat-ms-bj-public-api.sociolabs.io",
    "MS_CATALOG_API_URL": "https://uat-ms-catalog.sociolabs.io",
    "NEW_USER_LEVEL_V2":true,
    "MS_POS_API_URL": "https://uat-ms-pos.sociolabs.io",
    "MS_ANALYTICS_API_URL": "https://uat-analytics-api.sociolabs.io",
    "SOCO_WEB_URL": "https://uat-soco-web.sociolabs.io",
    "BJ_WEB_URL": "https://uat-bj-apps.sociolabs.io",
    "REVIEW_WEB_URL": "https://uat-review-web.sociolabs.io",
    "SOCIOLLA_WEB_URL": "https://uat-sociolla-web.sociolabs.io",
    "LULLA_WEB_URL": "https://uat-lilla-apps.sociolabs.io/",
    "MS_ACCOUNTS_API_URL": "https://uat-ms-accounts.sociolabs.io",
    "MS_ORDER_API_URL":"https://uat-ms-orders.sociolabs.io",
    "MS_REVIEW_API_URL": "https://uat-ms-reviews.sociolabs.io",
    "CENTRAL_LOGIN_WEB_URL": "https://uat-central-login.sociolabs.io",
    "RECAPTCHA_SITE_KEY": "6LdGhu0UAAAAAHRDh2bM97TEDB9UMBZSLjtsKe4F",
    "FB_APP_ID": "1030272380362840",
    "GOOGLE_CLIENT_ID": "266385423655-27dbsmtn7keg2tov39m2easdbd0gb8hv.apps.googleusercontent.com",
    "MS_SOCO_PUBLIC_API_LIST": [
        "https://uat-ms-soco-public-api.sociolabs.io"
    ],
    "MS_BJ_PUBLIC_API_LIST": [
        "https://uat-ms-bj-public-api.sociolabs.io"
    ],
    "MS_CATALOG_API_LIST": [
        "https://uat-ms-catalog.sociolabs.io"
    ],
    "MS_CART_API_LIST": [
        "https://uat-ms-cart.sociolabs.io"
    ]
};
